import React from 'react';
import img1 from '../assets/hero-banner.webp';
import { LiaChevronCircleRightSolid } from "react-icons/lia";

const Hero = () => {
  return (
    <div>
      <div className='container'>
        <div className='row hero-bg text-start align-items-center'>
          <div className='col-lg-6'>
            <h1>
              Empowering Lives Through Work
            </h1>
            <p className='pe-lg-4 hero-subtitle'>The best recruitment agency in the UK</p>

            <div className='d-flex align-items-center hero-cta'>
              <a href='https://skillworkers.co.uk/candidate/' className='d-flex align-items-center'>
                <button type="button">Get started now</button>
                <LiaChevronCircleRightSolid className="hero-cta-icon" />
              </a>
            </div>
          </div>

          <div className='col-lg-6 text-lg-end text-center'>
            <img src={img1} alt="Skill Workers hero" className='hero-banner-img spin' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
